import { CockpitKeyInitiativesSummary } from './CockpitKeyInitiativesSummary'

interface ICockpitKeyInitiativesCollapsedProps {
  onExpand: () => void
  isManagerCockpitMode?: boolean
}

export const CockpitKeyInitiativesCollapsed = ({
  onExpand,
  isManagerCockpitMode = false,
}: ICockpitKeyInitiativesCollapsedProps) => (
  <CockpitKeyInitiativesSummary onExpand={onExpand} isManagerCockpitMode={isManagerCockpitMode} />
)

CockpitKeyInitiativesCollapsed.displayName = 'CockpitKeyInitiativesCollapsed'
